// extracted by mini-css-extract-plugin
export var label = "_a7-1";
export var reminder = "_a7-0";